import React, { useState } from "react";
import { useFormik } from 'formik';
import InputField from "./formfield/InputField";
import service from "../services/anagrafica/Accessoutenteservice";
import errorSummary from "./crud/errorSummary";
import Translate from "./Translate";

import db from "../db";
import { useLiveQuery } from "dexie-react-hooks";

function RecuperaForm({ onChangeToLogin }) {

    const [msg, setMsg] = useState(null);
    const [fine, setFine] = useState(false);

    const langs = useLiveQuery(() => db.lingue.toArray());
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: '',
        },

        onSubmit: v => {
            if (!v.email) {
                setMsg(<Translate chiave="EMAILEMPTY" key="EMAILEMPTY" pacchetto="Login" />)
            } else {
                const values = { ...v };
                if (langs && langs.length !== 0) {
                    values.linguaId = langs[0].id;
                }
                service.recuperapsw(values).then(response => {
                    if (response.data.report && !response.data.mail) {
                        setMsg(<Translate chiave="EMAILNOTSEND" key="EMAILNOTSEND" pacchetto="Login" />)
                    } else {
                        setMsg('')
                        setFine(true);
                    }
                }).catch((error) => {
                    if (error.response && error.response.status === 422) {
                        setMsg(errorSummary(error.response.data)?.email);
                    } else {
                        setMsg(<Translate chiave="ERRORE" key="ERRORE" pacchetto="Login" />)
                    }
                });
            }
        },
    });
    return (
        <form onSubmit={formik.handleSubmit} style={{
            padding: '4rem 4rem 3rem 4rem',
        }}>
            <div className="d-flex justify-content-between flex-column" style={{ height: '25rem' }}>
                <div>
                    <div className="text-center">
                        <h1 className="h1 text-grigioch"><Translate chiave="RECUPEROPSW" pacchetto="Login" /></h1>
                        <div>

                        </div>
                    </div>

                    <div className="mt-5">
                        <InputField
                            readOnly={fine}
                            className="bg-grigioch loginbox"
                            labelprops={{
                                duepunti: false,
                                style: { display: 'block' }
                            }}
                            autoFocus={true}
                            onKeyPress={() => setMsg(null)}
                            name="email"
                            label="E-MAIL"
                            value={formik.values.email}
                            onChange={v => formik.setFieldValue('email', v.value)}
                        />
                    </div>
                    <div className="mt-3">
                        <small>
                            <Translate chiave="INSERTEMAIL" pacchetto="Login" />
                        </small>
                    </div>
                    <div className="mt-3">
                        {msg || '\u00A0'}
                    </div>
                    {fine && (
                        <>
                            <div className="font-weight-bold"><Translate chiave="EMAILSEND" pacchetto="Login" /></div>
                            <div><Translate chiave="CHECKYOURMAIL" pacchetto="Login" /></div>
                        </>
                    )}

                </div>
                <div>
                    <div className="d-flex justify-content-between" >
                        <div>
                            <button
                                onClick={onChangeToLogin}
                                type="button"
                                className="btn pt-0 pb-0 rotondo font-weight-semibold loginBtn"
                            ><Translate chiave="LOGINBACK" pacchetto="Login" /></button>
                        </div>
                        <div>
                            <button
                                type="submit"
                                className="btn btn-primary  rotondo text-primary p-1 font-weight-semibold loginBtn"
                            >
                                <Translate chiave="SENDMAIL" pacchetto="Login" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form >
    );
}

export default RecuperaForm;